import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/account/auth.service';
import { GlobalService } from '../services/global.service';
import { IdentityService } from '../services/identity.service';
import { ViewportScroller } from '@angular/common';
import { TenantService } from 'src/app/tenant/tenant.service';

@Component({
    selector: 'app-loading-spinner',
    templateUrl: './loading-spinner.component.html',
    styleUrls: ['./loading-spinner.component.scss'],
    standalone: false
})
export class LoadingSpinnerComponent implements OnInit {
  DontShow: boolean = true;
  logoSource: string = '';
  private logoCacheKey: string = '';
  constructor(public globalService: GlobalService, private identityService: IdentityService, private _router: Router,private authService: AuthService,
    private viewportScroller: ViewportScroller,
    private tenantService: TenantService
  ) {}

  ngOnInit(): void {
    document.getElementsByTagName('body')[0].style.minHeight = window.localStorage.getItem('bodyHeight'); 
    // this.viewportScroller.scrollToPosition([0, 0]);
    this.DontShow = false;
    void this.loadChurchLogo();
    // this.viewportScroller.scrollToPosition([0, 0]);
  } 

  onLogoError(): void {
    this.logoSource = '';
    if (this.logoCacheKey) {
      try {
        localStorage.removeItem(this.logoCacheKey);
      } catch { }
    }
  }

  private async loadChurchLogo(): Promise<void> {
    const tenant = this.getLoaderTenant();
    this.logoCacheKey = `church.smallLogo.${tenant}`;

    try {
      this.logoSource = localStorage.getItem(this.logoCacheKey) || '';
    } catch { }

    if (this.logoSource) return;

    try {
      const logoUrl = await this.tenantService.getTenantSmallLogo(tenant);
      if (!logoUrl) return;

      this.logoSource = logoUrl;
      try {
        localStorage.setItem(this.logoCacheKey, logoUrl);
      } catch { }
    } catch {
      // Keep the themed church-mark fallback if the logo is unavailable.
    }
  }

  private getLoaderTenant(): string {
    const pathTenant = window.location.pathname.split('/').filter(Boolean)[0]?.toLowerCase();
    const nonTenantRoutes = new Set(['home', 'login', 'signup', 'resetpassword', '404', 'admin', 'member', 'usher']);
    if (pathTenant && !nonTenantRoutes.has(pathTenant)) return pathTenant;

    try {
      const storedTenant = localStorage.getItem('tenant')?.toLowerCase();
      if (storedTenant) return storedTenant;
    } catch { }

    const host = window.location.hostname.toLowerCase();
    if (host.endsWith('.localhost')) {
      return host.slice(0, -'.localhost'.length).split('.').pop() || 'main';
    }

    const baseDomain = ['church-services.org', 'church-services-staging.org']
      .find(domain => host.endsWith(`.${domain}`));
    if (baseDomain) {
      const subdomain = host.slice(0, -(baseDomain.length + 1)).split('.').pop();
      if (subdomain && subdomain !== 'main') return subdomain;
    }

    return 'main';
  }
  
  GoHome(){ 
    this.identityService.authenticated = false;
    this.identityService.permissions = [];
    this.authService.logout(1);
    this._router.navigate([this.globalService.subdomain + '/login']);
  }   
}
           
